import React, { useState } from 'react';
import './DivinationPage.css';

const divinationResults = [
  '今天你的创造力会达到顶峰，试着去完成一个艺术项目吧。',
  '一个意想不到的机会即将出现，请保持开放的心态。',
  '是时候关注你的人际关系了，多花点时间和亲人朋友在一起。',
  '你的努力即将得到回报，坚持下去！',
  '今天适合学习新知识，无论是读书还是看一部纪录片。',
  '保持积极的心态，好运自然会向你走来。',
  '可能会遇到一些小挑战，但你有足够的能力去克服它们。',
  '一个老朋友可能会联系你，给你们的关系带来新的活力。',
];

const DivinationPage = () => {
  const [result, setResult] = useState('');
  const [isRevealed, setIsRevealed] = useState(false);

  const handleDivination = () => {
    const randomIndex = Math.floor(Math.random() * divinationResults.length);
    setResult(divinationResults[randomIndex]);
    setIsRevealed(true);
  };

  return (
    <>
      <title>每日占卜 - 星座探秘</title>
      <meta name="description" content="获取您的每日占卜指引。翻开卡片，揭示您今天的运势和提醒。" />
      <div className="divination-page">
        <h1>每日占卜</h1>
        <p>闭上眼睛，深呼吸，然后点击下方的卡片，揭示你今天的运势。</p>
        
        <div className={`card-container ${isRevealed ? 'revealed' : ''}`} onClick={handleDivination}>
          <div className="card-inner">
            <div className="card-front">
              <p>点击揭示</p>
            </div>
            <div className="card-back">
              <p>{result}</p>
            </div>
          </div>
        </div>

        {isRevealed && (
          <button className="reset-button" onClick={() => setIsRevealed(false)}>
            再试一次
          </button>
        )}
      </div>
    </>
  );
};

export default DivinationPage;
